import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { useInView } from 'react-intersection-observer';
import WhiteMarker from './WhiteMarker';

export default function ListingMap({ center, type, icon }) {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div className="listing-map-container" ref={ref}>
      {inView && (
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ' }}
          defaultCenter={center}
          defaultZoom={10}
        >
          <WhiteMarker
            type={type}
            lat={center.lat}
            lng={center.lng}
            icon={icon}
          />
        </GoogleMapReact>
      )}
    </div>
  );
}

ListingMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  type: PropTypes.oneOf([
    'properties',
    'activities',
    'shopping',
    'restaurants',
    'services',
  ]),
  icon: PropTypes.string,
};
